import React from 'react'
import { Pagination } from 'reactstrap'

export const PaginationComponent = (props) => {
  const {   
    setPage, page, limit, setLimit, totalPages
  } = props;
    console.log("🚀 ~ PaginationComponent ~ totalPages:", totalPages)
    console.log("🚀 ~ PaginationComponent ~ page:", page)

  return (
    <>
      <Pagination aria-label='...' style={{ justifyContent: "space-between" }}>
        <ul className='pagination pagination-primary'>
          {/* Botón Anterior */}
          <li 
            className={`page-item ${page === 1 ? 'disabled' : ''}`} 
            style={{ cursor: page === 1 ? 'not-allowed' : 'pointer' }}
            onClick={() => page > 1 && setPage(page - 1)}
          >
            <span className='page-link'>Anterior</span>
          </li>

          {/* Botones de página */}
          {page > 1 && (
            <>
              <li 
                className='page-item' 
                style={{ cursor: 'pointer' }} 
                onClick={() => setPage(1)}
              >
                <span className='page-link'>1</span>
              </li>
              {page > 2 && (
                <>
                  <li className="page-item"><span className='page-link'>...</span></li>
                  <li 
                    className="page-item" 
                    style={{ cursor: "pointer" }} 
                    onClick={() => setPage(page - 1)}
                  >
                    <span className='page-link'>{page - 1}</span>
                  </li>
                </>
              )}
            </>
          )}

          {/* Página actual */}
          <li className="page-item active primary">
            <span className='page-link'>{page}</span>
          </li>

          {/* Botones de página siguiente */}
          {page < totalPages && (
            <>
              {page < totalPages - 1 && (
                <>
                  <li 
                    className="page-item" 
                    style={{ cursor: 'pointer' }} 
                    onClick={() => setPage(page + 1)}
                  >
                    <span className='page-link'>{page + 1}</span>
                  </li>
                  <li className="page-item"><span className='page-link'>...</span></li>
                </>
              )}
              <li 
                className="page-item" 
                style={{ cursor: 'pointer' }} 
                onClick={() => setPage(totalPages)}
              >
                <span className='page-link'>{totalPages}</span>
              </li>
            </>
          )}

          {/* Botón Siguiente */}
          <li 
            className={`page-item ${page === totalPages ? 'disabled' : ''}`} 
            style={{ cursor: page === totalPages ? 'not-allowed' : 'pointer' }}
            onClick={() => page < totalPages && setPage(page + 1)}
          >
            <span className='page-link'>Siguiente</span>
          </li>
        </ul>
    </Pagination>
   
    </>
  )
}
